import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "empty_image.jpg",
    width: 600,
    height: 401
});